import React, { useEffect, useState } from "react";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import axios from "axios";

const ExpenseDescription = () => {
  const [expenseCategory, setExpenseCategory] = useState([]);
  const [selectedExpenseCategory, setSelectedExpenseCategory] = useState("");
  const [expenseCategoryOptions, setExpenseCategoryOptions] = useState([]);
  const [expenseCategoryData, setExpenseCategoryData] = useState({
    description: "",
    expense_category_id: "",
  });
  const [message, setMessage] = useState("");

  const baseAPI = process.env.REACT_APP_API_URL;

  const fetchExpenseCategory = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(
        `${baseAPI}adminget/GetExpenseDescriptionsWithCategory?expense_description_id=0&expense_category_id=0`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      const allCenters = response.data?.data;
      if (Array.isArray(allCenters)) {
        const activeCenters = allCenters.filter(
          (item) => item.is_active === true
        );
        setExpenseCategory(activeCenters);
      } else {
        alert("Unexpected data format received.");
      }
    } catch (error) {
      console.error("Fetch error:", error.response || error);
      alert("Failed to fetch Expense Category.");
    }
  };

  const fetchexpenseCategoryOptions = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(`${baseAPI}adminget/GetExpenseCategory?expense_category_id=0&expense_type_id=0`, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      });

      const allCenters = response.data?.data;
      if (Array.isArray(allCenters)) {
        const activeCenters = allCenters.filter(
          (item) => item.is_active === true
        );
        setExpenseCategoryOptions(activeCenters);
      } else {
        alert("Unexpected data format received.");
      }
    } catch (error) {
      console.error("Fetch error:", error.response || error);
      alert("Failed to fetch Expense Category1.");
    }
  };

  useEffect(() => {
    fetchExpenseCategory();
    fetchexpenseCategoryOptions();
  }, []);

 const handleSubmit = async () => {
  // Validate description
  if (!expenseCategoryData.description.trim()) {
    alert("Please enter Expense Category name.");
    return;
  }

  // Validate selected category
  if (!selectedExpenseCategory) {
    alert("Please select a Cost Center.");
    return;
  }

  // Build payload
  const payload = {
    description: expenseCategoryData.description.trim(),
    expense_category_id: parseInt(selectedExpenseCategory, 10),
  };

  console.log("Submitting payload:", payload);

  try {
    const storedToken = JSON.parse(localStorage.getItem("token"));

    const response = await axios.post(
      `${baseAPI}adminPost/AddExpenseDescriptionCategory`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${storedToken}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.status === 200 || response.status === 201) {
      alert("Expense Category added successfully!");

      // Reset only description and selected category (not full object)
      setExpenseCategoryData((prev) => ({ ...prev, description: "" }));
      setSelectedExpenseCategory("");

      // Refresh list
      fetchExpenseCategory();
    } else {
      alert("Failed to add Expense Category.");
    }
  } catch (error) {
    console.error("Error adding Expense Category:", error);

    if (error.response) {
      alert(`Error: ${error.response.data?.message || "Server error"}`);
    } else if (error.request) {
      alert("No response received from the server.");
    } else {
      alert(`Unexpected error: ${error.message}`);
    }
  }
};


  // Delete cost center (soft delete)
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this cost center?"))
      return;

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.post(
        `${baseAPI}adminPost/DeleteExpenseDescriptionCategory`,
        { expense_description_id: id.toString() },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Delete response:", response);

      if (response.status === 200 || response.status === 204) {
        alert("Expense Category deleted successfully.");
        fetchExpenseCategory();
      } else {
        alert("Failed to delete cost center.");
      }
    } catch (error) {
      console.error("Delete error:", error.response || error);
      alert(
        `Error: ${error.response?.data?.message || "Something went wrong."}`
      );
    }
  };

  const handleChange = (e) => {
    setExpenseCategoryData({
      ...expenseCategoryData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div
        className="container-fluid"
        style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
      >
        <div
          className="d-flex flex-column w-100"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                Expense Description | <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt; Master</span>
              </h1>
            </div>
            <div style={{ width: "8rem" }}>
              <select className="form-control" name="country">
                <option value="0">INDIA</option>
                <option value="1">DUBAI</option>
              </select>
            </div>
          </div>

          <Wrapper className="ViewLeadDetails mb-2">
            <div className="row">
           
  <div className="col-4">
    <div className="form-group mb-3">
      <label>Expense Description:</label>
      <input
        type="text"
        className="form-control"
        name="description"
        value={expenseCategoryData.description}
        onChange={handleChange}
        placeholder="Enter name"
      />
    </div>
  </div>
  <div className="col-4">
    <div className="form-group mb-3">
      <label>Expense Type:</label>
      <select
        className="form-control"
        value={selectedExpenseCategory}
        onChange={(e) => setSelectedExpenseCategory(e.target.value)}
      >
        <option value="">-- Select --</option>
        {expenseCategoryOptions.map((cc) => (
          <option
            key={cc.expense_category_id}
            value={cc.expense_category_id}
          >
            {cc.expense_type}
          </option>
        ))}
      </select>
    </div>
  </div>

   <div className="col-4">
    <div className="form-group mb-3 text-end">
<button className="btn btn-primary" onClick={handleSubmit}>
  Submit
</button>
    </div>
    </div>
</div>
</Wrapper>
<Wrapper className="ViewLeadDetails">


            {message && <p className="mt-3">{message}</p>}

            <h5 className="mt-4">Expense Description List</h5>
            <table className="table table-bordered">
              <thead className='SubCostCenterMaster-thead'>
                <tr>
                  <th>S.No</th>
                  <th>Expense Description Name</th>
                  <th>Expense Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody className='SubCostCenterMaster-tbody'>
                {Array.isArray(expenseCategory) &&
                expenseCategory.length > 0 ? (
                  expenseCategory.map((center, index) => (
                    <tr key={center.expense_description_id || index}>
                      <td>{index + 1}</td>
                      <td>{center.expense_description}</td>
                      <td >
                        {center.expense_type
                          ? center.expense_type
                          : "N/A"}
                      </td>
                      <td className='SubCostCenterMaster-td4'>
                        <button
                          className="btn btn-link text-danger p-0"
                          onClick={() =>
                            handleDelete(center.expense_description_id)
                          }
                          title="Delete"
                        >
                          <i className="fas fa-times"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </Wrapper>
        </div>
      </div>
    </div>
  );
};

export default ExpenseDescription;
